import { z } from "zod";

/**
 * Notification schema for dating app
 * Represents in-app notifications for matches, messages, etc.
 */
export const NotificationSchema = z.object({
  /** When the notification was created */
  time: z.date().optional().describe("Timestamp when notification was created"),

  /** User who should receive this notification */
  recipient: z.string().optional().describe("ID of the user receiving the notification"),

  /** Whether the notification has been viewed */
  viewed: z.boolean().optional().describe("Whether the notification has been seen"),

  /** Display name of the user who triggered the notification */
  senderName: z.string().optional().describe("Name of the user who caused this notification"),

  /** Type of notification (match, message, like, etc.) */
  type: z.string().optional().describe("Type of notification (match, message, like, etc.)"),

  /** Notification content/message */
  text: z.string().optional().describe("Notification message content"),
});

export type Notification = z.infer<typeof NotificationSchema>;
